import { setCookie, getCookie, removeCookie } from '@/utils/cookies';

const user = {
  state: {
    name: getCookie('userName') || '',
    jwt: getCookie('jwt') || '',
    hasPermission: false,
    permissionList: []
  },
  mutations: {
    setName: (state, name) => {
      state.name = name;
    },
    
    setJwt: (state, jwt) => {
      state.jwt = jwt;
    },
    
    setPermissionList: (state, list) => {
      state.hasPermission = true;
      state.permissionList = list;
    },
    
    resetAllState: (state) => {
      removeCookie('userName');
      removeCookie('jwt');
      state.name = '';
      state.jwt = '';
      state.hasPermission = false;
      state.permissionList = [];
    }
  },
  actions: {
    setName: ({ commit }, data) => {
      return new Promise(resolve => {
        setCookie('userName', data.name, { expires: 7 });
        setCookie('jwt', data.jwt, { expires: 7 });
        commit('setName', data.name);
        commit('setJwt', data.jwt);
        
        resolve();
      });
    },
    
    setPermissionList: ({ commit }, list) => {
      return new Promise(resolve => {
        commit('setPermissionList', list);
        
        resolve();
      });
    },
    
    logOut: ({ commit }) => {
      return new Promise(resolve => {
        commit('resetAllState');
        
        resolve();
      });
    }
    
  }
};

export default user;
